import { ApiMeansOfTransportType } from '../types/meansOfTransportType.types';
import { MeansOfTransportType } from '../../sharedComponents/common.types';

export const mapToMeansOfTransportType = (apiMeansOfTransportType: ApiMeansOfTransportType): MeansOfTransportType => {
    switch (apiMeansOfTransportType) {
        case ApiMeansOfTransportType.TRUCK:
            return MeansOfTransportType.TRUCK;
        case ApiMeansOfTransportType.OWN_WHEELS:
            return MeansOfTransportType.OWN_WHEELS;
        case ApiMeansOfTransportType.RORO_VESSEL:
            return MeansOfTransportType.RORO_VESSEL;
        case ApiMeansOfTransportType.CONTAINER_VESSEL:
            return MeansOfTransportType.CONTAINER_VESSEL;
        case ApiMeansOfTransportType.TRAIN:
            return MeansOfTransportType.TRAIN;
    }
};

export const mapToApiMeansOfTransportType = (meansOfTransportType: MeansOfTransportType): ApiMeansOfTransportType => {
    switch (meansOfTransportType) {
        case MeansOfTransportType.TRUCK:
            return ApiMeansOfTransportType.TRUCK;
        case MeansOfTransportType.OWN_WHEELS:
            return ApiMeansOfTransportType.OWN_WHEELS;
        case MeansOfTransportType.RORO_VESSEL:
            return ApiMeansOfTransportType.RORO_VESSEL;
        case MeansOfTransportType.CONTAINER_VESSEL:
            return ApiMeansOfTransportType.CONTAINER_VESSEL;
        case MeansOfTransportType.TRAIN:
            return ApiMeansOfTransportType.TRAIN;
    }
};
